import { MAXIMUM_WINDOW_HEIGHT_FOR_MODAL_CALENDAR } from "./constants";
export var isDisplayedAsModal = function isDisplayedAsModal(windowHeight) {
  return !!windowHeight && windowHeight < MAXIMUM_WINDOW_HEIGHT_FOR_MODAL_CALENDAR;
};